export const microservices = {
    captcha: {
        dev: 'v1',
        stg: 'v1',
        prod: 'v100'
    },
    aggregator: {
        dev: 'v6',
        stg: 'v4',
        prod: 'v100'
    },
    appcatalogue: {
        dev: 'v3',
        stg: 'v1',
        prod: 'v100'
    },
    mailservice: {
        dev: 'v12',
        stg: 'v15',
        prod: 'v100'
    },
    messagingservice: {
        dev: 'v15',
        stg: 'v20',
        prod: 'v100'
    },
    notification: {
        dev: 'v3',
        stg: 'v3',
        prod: 'v100'
    },
    pdfgenerator: {
        dev: 'v1',
        stg: 'v1',
        prod: 'v100'
    },
    pdfgenerator2: {
        dev: 'v24',
        stg: 'v26',
        prod: 'v100'
    },
    securestorage: {
        dev: 'v2',
        stg: 'v1',
        prod: 'v100'
    },
    shortmessage: {
        dev: 'v3',
        stg: 'v5',
        prod: 'v100'
    },
    storageservice: {
        dev: 'v22',
        stg: 'v23',
        prod: 'v100'
    },
    templateengine: {
        dev: 'v17',
        stg: 'v21',
        prod: 'v100'
    },
    tenant: {
        dev: 'v2',
        stg: 'v2',
        prod: 'v100'
    },
    workflow: {
        dev: 'v32',
        stg: 'v32',
        prod: 'v100'
    },
    identity: {
        dev: 'v20',
        stg: 'v25',
        prod: 'v100'
    },
    urlShortner: {
        dev: 'v3',
        stg: 'v4',
        prod: 'v100'
    },
    uam: {
        dev: 'v23',
        stg: 'v33',
        prod: 'v100'
    },
    twoFa: {
        dev: 'v1',
        stg: 'v1',
        prod: 'v100'
    },
    selisign: {
        dev: 'v42',
        stg: 'v65',
        prod: 'v100'
    },
    uilm: {
        dev: 'v15',
        stg: 'v18',
        prod: 'v100'
    },
    pds: {
        dev: 'v1',
        stg: 'v1',
        prod: 'v100'
    },
    gqlcommand: {
        dev: 'v7',
        stg: 'v7',
        prod: 'v200'
    },
    gqlquery: {
        dev: 'v7',
        stg: 'v7',
        prod: 'v200'
    },
    calendarservice: {
        dev: 'v3',
        stg: 'v3',
        prod: 'v100'
    },
    linkbaseaction: {
        dev: 'v2',
        stg: 'v1',
        prod: 'v100'
    },
    documentManagerService: {
        dev: 'v40',
        stg: 'v46',
        prod: 'v100'
    },
    sequenceNumberService: {
        dev: 'v2',
        stg: 'v1',
        prod: 'v100'
    }
};
